import { render, staticRenderFns } from "./IntroductionCenterPage.vue?vue&type=template&id=4624e04b&scoped=true&"
import script from "./IntroductionCenterPage.vue?vue&type=script&lang=js&"
export * from "./IntroductionCenterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4624e04b",
  null
  
)

export default component.exports